'use client';

/**
 * Shared crash-screen markup for both error surfaces: the app-shell
 * ErrorBoundary and the root global-error page. Inline styles only — the
 * global-error page renders after the root layout (and globals.css) is
 * gone, so this component must carry its own presentation.
 */

export function ErrorFallback({ onRetry }: { onRetry: () => void }) {
  return (
    <div style={{ padding: 40, textAlign: 'center' }}>
      <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}>Something went wrong</h2>
      <p style={{ color: '#6b7280', marginBottom: 16 }}>
        An unexpected error occurred. Please try again or refresh the page.
      </p>
      <button
        onClick={onRetry}
        style={{ padding: '8px 16px', borderRadius: 6, background: '#4f46e5', color: '#fff', border: 'none', cursor: 'pointer' }}
      >
        Try Again
      </button>
    </div>
  );
}
